export const getFileExtension = (fileName) => {
  const fileNameArr = fileName.split('.');
  return fileNameArr[fileNameArr.length - 1];
};
